import { Component, ɵCompiler_compileModuleSync__POST_R3__ } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem, CdkDrag } from '@angular/cdk/drag-drop';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-route-business-map',
  templateUrl: './route-business-map.component.html',
  styleUrls: ['./route-business-map.component.scss']
})
export class RouteBusinessMapComponent {
  businesses = [];

  route_businesses = [];
  routes = [];
  selected_route_id: number = null;
  all_business: any;
  display_all_business = false
  search_term = null;
  unassigned_business: any;
  all_selected_route_id = null;
  filtred_all_routes: any;
  selected_route_name: any;
  route_name: any;
  is_route_change_available = true;
  time_range_for_limit: any;
  employee_user_type_id: any;
  // route_list = {
  //   route_id: [{ business_id, business_name }]
  // };


  constructor(private http: HttpService, private global: GlobalService) {
    this.http.serveFromTimeForBoothChange().subscribe((data) => {
      console.log(data);
      if (new Date().getHours() >= data['from_time']) {
        this.is_route_change_available = true;
      } else {
        this.is_route_change_available = false;
      }
      console.log(this.is_route_change_available);
      this.getAllBusiness();
      this.getRoutes();
    }, (error) => {
      console.error(error);
    });
    this.global.set_master_page_title = 'Booth Route Map';
    this.http.getEmployeeUserType().subscribe((data) => {
      console.log(data);
      this.employee_user_type_id = data;
      if (this.employee_user_type_id === 2) {
        this.is_route_change_available = true;
      }
    }, (error) => {
      console.error(error);
    });
  }


  drop(event: CdkDragDrop<string[]>, direction: string) {
    console.log('drag worked');
    if (this.selected_route_id === null) {
      alert('please select route first');
      return false;
    }
    // drop(event: CdkDragDrop<string[]>, drop: CdkDrag) {
    // console.log('drag data = ' + JSON.stringify(event.container.data));
    // console.log('drop data = ' + JSON.stringify(event.item.dropContainer.data));
    // console.log(event.previousContainer.data);
    console.log(event.item.data);
    console.log(event)
    if (event.previousContainer === event.container) {
      // console.log('drop data = ' + JSON.stringify(event.item.dropContainer.data));
      // console.log(this.route_businesses);
      console.log('route order change function runned');
      console.log('event.previousIndex', event.previousIndex);
      console.log('event.currentIndex', event.currentIndex);
      const data_dict = {
        'selected_business': event.item.data,
        'previous_index': event.previousIndex,
        'current_index': event.currentIndex,
        'selected_route_id': this.selected_route_id,
        operation: 'ordinal_update'
      }
      this.http.changeBusinessArrayOrder(data_dict).subscribe((data) => {
        this.getBusinessByRoute();
      })
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      console.log(direction);
      console.log('moved another array');
      if (direction === 'business_to_route') {
        this.routeBusinessMap(event.item.data['id'], event.currentIndex);
      } else if (direction === 'route_to_business') {
        this.removeBusinessFromRoute(event.item.data['id']);
      }
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }

  routeSelected(route_id) {
    console.log(route_id);
    this.selected_route_id = route_id;
    // this.selected_route_name = route_id;
    this.getBusinessByRoute();

  }

  getAllBusiness() {
    this.http.getAllbusiness().subscribe((data: []) => {
      console.log(data);
      // this.businesses = data;
      this.all_business = data;
    }, (error) => {
      console.log(error);
    });
  }

  getRoutes() {
    this.http.getRoutes().subscribe((data: []) => {
      console.log(data);
      this.routes = data;
    }, (error) => {
      console.log(error);
    });
  }

  routeChanged(event) {
    console.log(event.target.value);
    this.selected_route_id = event.target.value;
    console.log(this.selected_route_id);
    this.getBusinessByRoute();
  }


  removeBusinessFromRoute(business_id) {
    const data_dict = {
      route_id: this.selected_route_id,
      business_id: business_id,
      operation: 'remove_business'
    };
    this.http.changeBusinessArrayOrder(data_dict).subscribe((data) => {
      this.http.removeBusinessFromRoute(data_dict).subscribe((res_data) => {
        console.log(res_data);
        if (!res_data['is_time_available']) {
          alert('உங்களால் Booth ஐ மாற்ற இயலாது . இந்த Booth உடைய ஆர்டர் முன்னராகவே பதிவு செய்யப்பட்டுவிட்டது !!');
        } else {
          this.global.showSnakeBar(res_data['message']);
        }
        this.getBusinessByRoute();
      }, (error) => {
        console.log(error);
      });
    });
  }

  routeBusinessMap(business_id, current_index) {
    const data = {
      route_id: this.selected_route_id,
      business_id: business_id,
      current_index: current_index
    };
    this.http.routeBusinessMap(data).subscribe((res_data) => {
      console.log(res_data)
      if (res_data['is_time_available']) {
        if (res_data['status'] == 'alert') {
          alert(res_data['message']);
          this.getBusinessByRoute();
        }
        if (res_data['status'] == 'confirm') {
          if (confirm(res_data['message'])) {
            data['route_map_id'] = res_data['route_map_id']
            this.changeRouteBusinessMap(data)
          }
          else {
            this.getBusinessByRoute();
            this.getFilteredRoute();
          }
        }
        if (res_data['status'] == 'toast') {
          this.getBusinessByRoute();
          this.getFilteredRoute();
          this.global.showSnakeBar('Route Mapped Successfully!');
          if (this.display_all_business) {
          }
        }
      } else {
        alert('உங்களால் Booth ஐ மாற்ற இயலாது . இந்த Booth உடைய ஆர்டர் முன்னராகவே பதிவு செய்யப்பட்டுவிட்டது !!');
        this.getBusinessByRoute();
        this.getFilteredRoute();
        return false;
      }
    }, (error) => {
      console.log(error);
    });
  }

  changeRouteBusinessMap(data) {
    this.http.updateBusinessRouteMap(data).subscribe((data) => {
      console.log(data);
      this.getBusinessByRoute();
      this.global.showSnakeBar('Route Mapped updated Successfully!');
    })
  }

  getBusinessByRoute() {
    const route_data = { route_id: this.selected_route_id };
    this.getUnmapedBusinessWithRoute()
    this.http.getBusinessByRoute(route_data).subscribe((data: []) => {
      console.log(data);
      this.route_businesses = data['businesses'];
      this.selected_route_name = data['route_name']
    }, (error) => {
      console.log(error);
    });
  }

  evenPredicate(item: CdkDrag<any>) {
    console.log(item);
    return true;
  }

  getUnmapedBusinessWithRoute() {
    const data = {
      route_id: this.selected_route_id,
    };
    this.http.getUnmapedBusinessWithRoute(data).subscribe((res_data: []) => {
      console.log(res_data);
      this.unassigned_business = res_data;
    }, (error) => {
      console.log(error);
    });
  }


  search(search_term) {
    console.log('filter', this.search_term);
    if (this.all_selected_route_id != null) {
      this.businesses = this.filtred_all_routes
    }
    else {
      this.businesses = this.all_business
    }
    if (this.search_term == undefined || this.search_term == '' || this.search_term == null) {
      this.display_all_business = false
    }
    else {
      this.display_all_business = true
      this.businesses = this.businesses.filter((business) => {
        return business['name'].toLowerCase().indexOf(this.search_term.toLowerCase()) > -1;
      });
    }
  }

  allrouteSelected(route_id) {
    console.log(route_id);
    this.all_selected_route_id = route_id;
    console.log(this.all_selected_route_id);
    this.getFilteredRoute()
  }

  getFilteredRoute() {
    const route_data = { route_id: this.all_selected_route_id };
    this.http.getBusinessByRoute(route_data).subscribe((data: []) => {
      console.log(data);
      this.businesses = data['businesses'];
      this.filtred_all_routes = data['businesses']
    }, (error) => {
      console.log(error);
    });
  }

  ChangeActiveStatus(business_id, action) {
    const data_dict = {
      'business_id': business_id,
      'action': action
    }
    this.http.changeBusinessActiveStatus(data_dict).subscribe((data) => {
      console.log('data');
      this.getBusinessByRoute();
    })
  }
  remove() {

  }
}

